import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-viscosity-grade-page',
  templateUrl: './viscosity-grade-page.component.html',
  styleUrls: ['./viscosity-grade-page.component.scss']
})
export class ViscosityGradePageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
